module.exports = __webpack_public_path__ + "static/img/yongji.e1172e4.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/yongji.gif
// module id = DImz
// module chunks = 1